const STATUS = {
  IDLE: "IDLE",
  STARTED: "STARTED",
  STOPPED: "STOPPED"
};

export const pollApi = ({
  pollFn,
  shouldStopPolling = () => true,
  onError,
  onComplete,
  maxPollCount = 30,
  delayDuration = 3000
}) => {
  if (!pollFn) {
    console.error("Poll function should not be undefined or null");
  }
  let timer = null;
  let pollCount = 0;
  let status = STATUS.IDLE;
  const start = async () => {
    try {
      if (status === STATUS.STOPPED) return;
      const response = await pollFn();
      pollCount += 1;
      if (pollCount >= maxPollCount) {
        throw new Error("Maximum Polling Exceeded");
      } else if (shouldStopPolling(response)) {
        stop();
        onComplete?.(response);
        return;
      }
      timer = setTimeout(() => {
        start();
      }, delayDuration);
    } catch (error) {
      stop();
      onError?.(error);
    }
  };
  const stop = () => {
    if (status === STATUS.STOPPED) return;
    status = STATUS.STOPPED;
    timer && clearTimeout(timer);
    timer = null;
    pollCount = 0;
  };

  return {
    stop,
    start: () => {
      if (status === STATUS.STARTED) return;
      status = STATUS.STARTED;
      start();
    }
  };
};
